import styled from "styled-components";

export default styled.div`
    padding: 20px;
    min-height: 300px;
    max-height: 70vh;
    overflow-y: auto;

    .modal-header {
        display: flex;
        justify-content: space-between;
        align-items: center;
        margin-bottom: 20px;
        padding-bottom: 15px;
        border-bottom: 1px solid ${(props) => props.theme.commentHistoryModalHeaderBorder};

        h2 {
            color: ${(props) => props.theme.commentHistoryModalHeaderText};
            font-size: 24px;
            font-weight: 600;
            margin: 0;
            letter-spacing: 1px;
        }

        .close-button {
            cursor: pointer;
            color: ${(props) => props.theme.commentHistoryCloseButton}
        }
    }

    .modal-content {
        display: flex;
        flex-direction: column;
        gap: 15px;

        .history-item {
            background-color: ${(props) => props.theme.votingCellBackground};
            border: 1px solid ${(props) => props.theme.votingCellBorder};
            border-radius: 8px;
            padding: 15px;
            transition: all 0.2s ease;

            &:hover {
                border-color: ${(props) => props.theme.commentHistoryHoverBorder};
                box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
            }

            .comment-header {
                display: flex;
                justify-content: space-between;
                align-items: center;
                margin-bottom: 10px;
                padding-bottom: 8px;
                border-bottom: 1px solid ${(props) => props.theme.commentHistoryDateBorder};

                .comment-date {
                    color: ${(props) => props.theme.commentHistoryDateText};
                    font-size: 12px;
                    font-weight: 500;
                }
            }

            .comment-text {
                color: ${(props) => props.theme.commentHistoryCommentText};
                font-size: 14px;
                line-height: 1.5;
                white-space: pre-wrap;
                word-break: break-word;
            }
        }
    }
`;
